const FilterBy = ({ setFilterBy }) => {
  const onChange = (event) => {
    setFilterBy(event.target.value);
  };

  return (
    <div className='filterMenu'>
      <label htmlFor='category'>Filter by</label>
      <select id='category' onChange={onChange}>
        <option value='All'>All</option>
        <option value='Tools'>Tools</option>
        <option value='Brain Modifications'>Brain Modifications</option>
        <option value='Immune System Modifications'>
          Immune System Modifications
        </option>
        <option value='Nervous System Modifications'>
          Nervous System Modifications
        </option>
        <option value='Arm Modifications'>Arm Modifications</option>
        <option value='Circulatory System Modifications'>
          Circulatory System Modifications
        </option>
        <option value='Ocular System Modifications'>
          Ocular System Modifications
        </option>
      </select>
    </div>
  );
};

export default FilterBy;
